import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITopicResource } from "../types";

export type ITopicStartMutationParameters = {
    topic: RelationalValue<ITopicResource>;
};

export type ITopicStartMutationResult = ITopicResource;

export const topicStartMutation: IApiMutationFunction<ITopicStartMutationParameters> = ({ topic }) => ({
    method: "PUT",
    url: `/topics/${mapRelationalValue(topic)}/start`,
    data: {},
});

export const useTopicStartMutation = createApiMutationHook<ITopicStartMutationParameters, ITopicStartMutationResult>(
    topicStartMutation,
);
